import { element } from "./dom";

type AuthStatus = { authenticated: boolean };

export async function requireSiteAccess(app: HTMLElement, onAuthenticated: () => void): Promise<void> {
  try {
    const response = await fetch("/api/auth/status", { headers: { accept: "application/json" } });
    const status = (await response.json()) as AuthStatus;
    if (status.authenticated) {
      onAuthenticated();
      return;
    }
  } catch {
    // The login view below also handles a temporarily unreachable Worker.
  }
  renderLogin(app, onAuthenticated);
}

function renderLogin(app: HTMLElement, onAuthenticated: () => void): void {
  document.body.className = "app-body app-body--centered";
  document.title = "Inloggen · IRL Bingo";

  const eyebrow = element("p", { className: "eyebrow", text: "BINGO.KEVINNLPG.COM" });
  const title = element("h1", { className: "login-card__title", text: "De streamruimte is vergrendeld." });
  const description = element("p", {
    className: "login-card__description",
    text: "Voer het sitewachtwoord in om kaarten aan te maken of te bedienen.",
  });
  const label = element("label", { className: "field-label", text: "Wachtwoord", attrs: { for: "site-password" } });
  const input = element("input", {
    className: "text-input text-input--large",
    attrs: {
      id: "site-password",
      name: "password",
      type: "password",
      autocomplete: "current-password",
      required: "",
      autofocus: "",
    },
  });
  const error = element("p", { className: "form-error", attrs: { role: "alert" } });
  const button = element("button", { className: "button button--primary button--wide", text: "Ontgrendelen" });
  const form = element("form", { className: "login-card__form", children: [label, input, error, button] });
  const lockIcon = element("div", { className: "login-card__lock", text: "B", attrs: { "aria-hidden": "true" } });
  const card = element("section", {
    className: "login-card",
    attrs: { "aria-labelledby": "login-title" },
    children: [lockIcon, eyebrow, title, description, form],
  });
  title.id = "login-title";
  app.replaceChildren(card);

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    error.textContent = "";
    button.disabled = true;
    button.textContent = "Controleren…";
    try {
      const response = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "content-type": "application/json", accept: "application/json" },
        body: JSON.stringify({ password: input.value }),
      });
      const body = (await response.json()) as { authenticated?: boolean; error?: string };
      if (!response.ok || !body.authenticated) throw new Error(body.error ?? "Inloggen is niet gelukt.");
      app.replaceChildren();
      onAuthenticated();
    } catch (cause) {
      error.textContent = cause instanceof Error ? cause.message : "Inloggen is niet gelukt.";
      input.select();
    } finally {
      button.disabled = false;
      button.textContent = "Ontgrendelen";
    }
  });
}

export async function logOut(): Promise<void> {
  await fetch("/api/auth/logout", { method: "POST" });
  location.assign("/");
}
